// import PLAY_STORE_LOGO_URL from "./assets/images/google-play.png";
// import APP_STORE_LOGO_URL from "./assets/images/app-store.svg";

export const PLAY_STORE_LOGO_URL =
  "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";
export const APP_STORE_LOGO_URL =
  "https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg";

export const TEACH_PLAY_STORE_URL = "http://api.edify.fit:18000";
export const TEACH_APP_STORE_URL = "http://api.edify.fit:18000";

export const LEARN_PLAY_STORE_URL = "http://api.edify.fit:18000";
export const LEARN_APP_STORE_URL = "http://api.edify.fit:18000";

export const COMMON_ERROR = "Sorry, something went wrong. Please try again.";

export const LOGGED_OUT_ERROR =
  "Oh, you've been logged out. Please login again.";

export const SUPPORT_EMAIL_ID = "help@edify.fit";

export const CONTACT_US = "Contact Us";

export const TERMS_OF_USE = "Terms of use";

export const PRIVACY_POLICY = "Privacy policy";

export const ALL_RIGHTS_RESERVED = "© 2021 www.edify.fit. All rights reserved.";

export const BOOTSTRAP_COLORS = {
  SUCCESS: "28a745",
  DANGER: "dc3545",
  MUTED: "f7f7f7",
};
